import { CONSTANTS, AttributeName } from "client/utils/constants";
import moment from "moment";
import { v1 as uuid } from "uuid";
import * as XLSX from 'xlsx';
import { getBudgetingPercentList, getCatalogUpdateCapacity, getCatalogUpdateDriveTrain, getCatalogUpdateEqClassCode, getCatalogUpdateMake, getCatalogUpdateStateAvailability, getCatalogUpdateNoOfDoors, getCatalogUpdatePowerType, getCatalogUpdateUpfit, getCatalogUpdateVehicleLevel, getCatalogUpdateYear, getUsefulLifeList, getCatalogUpdateProgramStatus, getCatalogUpdateAnnualHours, getCatalogUpdateDeckSize, getCatalogUpdateDeckType, getCatalogUpdateSize, getCatalogUpdateLength, getCatalogUpdateAutonomous, getCatalogUpdateCategoryType, getCatalogUpdateCategory2, getCatalogUpdateType, getCatalogUpdateCategory, getTagsList, getCatalogUpdateVehicleClass, getCatalogUpdateGroupType, getCatalogUpdateClassType, getCatalogUpdateGrossWeight, getCatalogUpdateTrim } from "Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateAction";

export const formatLableValue = (value: string | null | undefined): string =>
  value ?? "-";

export const getFileName = (url: string) => {
  const path = decodeURI(url).split("/");
  const filePath = path[path.length - 1]?.split("?")
  const fileName = filePath[0]
  return fileName;
};

export const reasonGrowthTypes = [
  {
    disabled: false,
    group: null,
    selected: false,
    text: "New Employee",
    value: "1",
  },
  {
    disabled: false,
    group: null,
    selected: false,
    text: "New Business",
    value: "2",
  },
];

export const dropdownCollection = Object.freeze({
  vehicleType: "Vehicle Type",
  truckSize: "Truck Size",
  noOfDoors: "No. of Doors",
  make: "Make",
  model: "Model",
  driverTitle: "Driver Title",
  manufacturerDropDown: "Manufacturer",
  programStatusDropDown: "Program Status",
  annualHoursDropDown: "Annual Hours",
  categoryDropDown: "Category",
  stateAvailabilityDropDown: "State Availability",
  deckSizeDropDown: "Deck Size",
  deckTypeDropDown: "Deck Type",
  autonomousDropDown: "Autonomous",
  seatingCapacityDropDown: "Seating Capacity",
  utilityManufactureDropDown: "Manufacturer",
  UtilityEnclosedcabDropDown: "Enclosed Cab",
  utilityCapacityDropDown: "Capacity",
  trailermanufactureDropDown: "Manufacturer",
  trailerStyleDropDown: "Style",
  trailerLengthDropDown: "Length",
  trailerFuelTankDropDown: "Fuel Tank",
  trailerChargingStationDropDown: "Charging Station",
  snowManufactureDropDown: "Manufacturer",
  snowCategoryDropDown: "Category",
  snowSizeDropDown: "Size",
  snowTypeDropDown: "Type",
  developmentCategoryDropDown: "Category",
  developmentManufactureDropDown: "Manufacturer",
  TreeManufactureDropDown: "Manufacturer",
  TreeEquipmentDropDown: "Equipment Type",
  TreeHorsePowerDropDown: "Horse Power",
  TreeFuelTypeDropDown: "Fuel Type",
  standardcategoryDropdown: "Category",
  standardManufactureDropdown: "Manufacturer"
})

export const CATALOG_RESET_MESSAGE = "Catalog filters has been reset."

// Format Price Values with Commas at Thousands
export const formatPrice = (value: any, decimal: number): string => {
  if (!value) value = 0;
  value = value?.toString()?.replace(/[^\d.]|\.(?=.*\.)/g, "")
  let regex = new RegExp(/(\d)(?=(\d{3}){1,25}(?!\d))/, "g")
  return parseFloat(value)?.toFixed(decimal)?.replace(regex, '$1,');
};

// Format a currency value (defaults to budgeting price style)
export const getBudgetingPriceDisplay = (value: any): string => {
  const numeric = value === null || value === undefined || value === "" ? 0 : Number(value);
  return `$${formatPrice(Number.isFinite(numeric) ? numeric : 0, 2)}`;
};

// Check if only Numbers, Comma, dot or Backspace exists
export const isNumber = (event: any): boolean => {
  let theEvent = event || window.event;
  let key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);
  theEvent.returnValue = true;

  let regex = /^[0-9.,\b]+$/;
  if (!regex.test(key) || (key == '.' && event.target.value.split('.').length == 2)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
  return theEvent.returnValue;
}

export const isAlphaNumeric = (event: any): boolean => {
  let theEvent = event || window.event;
  let key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);
  theEvent.returnValue = true;

  let regex = /^[a-zA-Z0-9\b]+$/;
  if (!regex.test(key) || (key == '.' && event.target.value.split('.').length == 2)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
  return theEvent.returnValue;
}

// Remove E1 restricted special characters
export const sanitizeE1Input = (value: string): string => {
  if (!value) return value;
  return value.replace(/[\n\r\f\t\b\\'\"]/g, '');
};

// Check if only Numbers, Comma or Backspace exists
export const isNumberWithoutDecimal = (event: any): boolean => {
  let theEvent = event || window.event;
  let key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);
  theEvent.returnValue = true;

  let regex = /^[0-9,\b]+$/;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
  return theEvent.returnValue;
}

// Check if only Numbers with up to 1 decimal place
export const isNumberWithOneDecimal = (event: any): boolean => {
  let theEvent = event || window.event;
  let key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);
  theEvent.returnValue = true;

  let regex = /^[0-9.,\b]+$/;
  const value = event.target.value || '';
  const decimalSplit = value.split('.');
  
  // Prevent multiple decimal points
  if (key == '.' && decimalSplit.length == 2) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
    return theEvent.returnValue;
  }
  
  // Prevent typing if already has 1 decimal digit
  if (decimalSplit.length == 2 && decimalSplit[1].length >= 1 && regex.test(key) && key != '.') {
    const selectionStart = event.target.selectionStart;
    const selectionEnd = event.target.selectionEnd;
    const decimalIndex = value.indexOf('.');
    
    // Only prevent if cursor is after decimal point and no text is selected
    if (selectionStart > decimalIndex && selectionStart === selectionEnd) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
      return theEvent.returnValue;
    }
  }
  
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
  return theEvent.returnValue;
}

export const isMaxLength = (event: any, maxLength: any): boolean => {

  let theEvent = event || window.event;
  theEvent.returnValue = true;

  if (event.target.value.length >= maxLength) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
  return theEvent.returnValue;
}

export const AN_TYPES: any = {
  Application: "In Application",
  Email: "As an Email",
  SMS: "As a Text Message",
};

export const isEmail = (value: any): boolean => {
  let isValid;
  let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
  if (value < 0 || emailRegex) {
    isValid = false;
  }
  else {
    isValid = true;
  }
  return isValid;
}

export const isValidPhone = (value: any) => {
  let isValid;
  let phoneVal = value?.match(/\d/g);
  if (phoneVal === null || phoneVal.length < 10 || phoneVal?.toString().trim()?.length == 0) {
    isValid = false;
  } else {
    isValid = true
  }
  return isValid;
}


export const apiMethod = {
  GET: "Get",
  POST: "Post",
  PUT: "Put",
  DELETE: "Delete",
}

export const apiType = {
  OrderManagement: "OrderManagement",
  AssetManagement: "AssetManagement",
  FleetManagement: "FleetManagement",
  Notification: "Notification",
  Organization: "Organization",
  Identity: "Identity"
}



export const API_URL = {
  PostWebApp: "api/WebApp"
}

export const Application = {
  Select: "Select",
  REACT: "REACT",
  API: "API"
}

export const returGridHeaderClassName = (status: any) => {
  let src = "";
  switch (status) {
    case CONSTANTS?.GRID_ACTIVE_MENU?.PENDING_APPROVAL:
      src = 'pendingapprovals';
      break;
    case CONSTANTS?.GRID_ACTIVE_MENU?.TOTAL_ORDERS:
      src = 'myorders';
      break;
    case CONSTANTS?.GRID_ACTIVE_MENU?.PENDING_FLEET_PROCESSING:
    case CONSTANTS?.GRID_ACTIVE_MENU?.FLEET_PROCESSING:
      src = 'fleetprocessing';
      break;
    case CONSTANTS?.GRID_ACTIVE_MENU?.COMPLETED:
      src = 'completed';
      break;
    case CONSTANTS?.GRID_ACTIVE_MENU?.RETURNED:
      src = 'returned';
      break;
    case CONSTANTS?.GRID_ACTIVE_MENU?.REJECTED:
      src = 'rejected';
      break;
    case CONSTANTS?.GRID_ACTIVE_MENU?.CANCELLED:
      src = 'cancelled';
      break;
    case CONSTANTS?.GRID_ACTIVE_MENU?.SAVED:
      src = 'saved';
      break
    default:
      break;
  }
  return src;
}

export const base64ToArrayBuffer = (base64: any) => {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export const saveByteArray = (fileName: any, byteData: any, fileType: any) => {
  const blob = new Blob([byteData], { type: fileType });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};


// Check if only Numbers, Comma, dot, minus or Backspace exists
export const isNumberWithSign = (event: any): boolean => {
  let theEvent = event || window.event;
  let key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);
  theEvent.returnValue = true;

  let regex = /^[0-9\-.,\b]+$/;
  if (!regex.test(key) || (key == '.' && event.target.value.split('.').length == 2)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
  return theEvent.returnValue;
}

// Extract only numbers from a Given value with negative sign
export const getOnlyNumbersWithSign = (item: any) => {
  if (!item) item = 0;
  return item.toString()?.replace(/[^\d.-]|\.(?=.*\.)/g, "")
}

// Format Price Values with Commas at Thousands and negative values
export const formatPriceWithSign = (value: any, decimal: number): string => {
  if (!value) value = 0;
  let amount = getOnlyNumbersWithSign(value)
  if (isNaN(amount)) {
    return ""
  } else {
    let formatedAmount = new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimal, maximumFractionDigits: decimal }).format(amount,)
    return formatedAmount
  }
};

export const fetchGridPayload = (payload: any, dateRange: any, searchValue: any, sortData: any, isGlobalSearchByValue?: any, globalSearchBy?: any) => {
  let fromDateHome: any = ''
  let toDateHome: any = ''
  for (let i = 0; i < dateRange?.length; i++) {
    let val = dateRange[i].toString();
    let date = moment(new Date(val)).format('YYYY-MM-DD');
    if (i == 0) {
      fromDateHome = date;
    } else {
      toDateHome = date;
    }
  }
  if (fromDateHome != '' && toDateHome != '') {
    payload.fromDate = fromDateHome;
    payload.toDate = toDateHome
  }
  if (searchValue != '') {
    payload.globalSearch = searchValue
    if (isGlobalSearchByValue) {
      payload.globalSearchField = globalSearchBy
    }
  }

  if (sortData?.key != '') {
    payload.sortBy = sortData?.key;
    payload.sortOrder = sortData?.sortDirection;
  }
  return payload;
}

export const popupInitialData = {
  title: "",
  isDialogVisible: false,
  isTitleWarning: false,
  subtextcontent: "",
  primaryBtnText: "",
  outlineBtnText: "",
  isSingleConfirmationBtn: false,
  isCommentboxVisible: false,
  isCompletedReportVisible: false,
  titleImg: "",
  isCommentBoxRequire: false,
  outlineBtnnavigateTo: "",
  primaryBtnnavigateTo: "",
  actionby: "",
  value: 0,
  comment: "",
  popupOutlinebtnOnclick: () => { },
  popupPrimarybtnOnclick: () => { },
  hideDialog: () => { }
}

export const defaultBreadcrumList = (dispatchNav: any, headerNavItem: any, navigate: any, breadCrumbText: any) => [
  {
    text: "Home",
    key: "f1",
    href: "/ordermanagement",
    onClick: (e: any) => {
      e.preventDefault();
      dispatchNav(headerNavItem);
      navigate('/ordermanagement');
    },
  },
  { text: breadCrumbText, key: "f4" },
];

const getPopupContent = (
  titleImg: string,
  actionby: string,
  subtextcontent: any,
  titleText: string,
  isCompletedReportVisible: any,
  Popupcontent: any
) => {
  return {
    ...Popupcontent,
    titleImg,
    actionby,
    subtextcontent,
    title: titleText,
    isCompletedReportVisible,
    isDialogVisible: true,
    isTitleWarning: false,
    primaryBtnText: "",
    outlineBtnText: "Close",
    isSingleConfirmationBtn: true,
    isCommentboxVisible: false,
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "Home",
    primaryBtnnavigateTo: "",
  };
};

export const approvalPopupDisplay = (setPopupcontent: any, Popupcontent: any, isApprovalData: any, approvalAction: any, setIsOrderApprovalComplete: any, beeImage: any, erroOrderConfirmation: any) => {
  if (isApprovalData && isApprovalData === true) {
    if (approvalAction.actionby === "ReturnSubmitbtn") {
      setPopupcontent({
        ...getPopupContent(
          beeImage.SuccessBee,
          "ReturnConfirmationBtn",
          approvalAction.returnOrderconfirmation,
          "Returned",
          false,
          Popupcontent
        ),
      });
    }
    if (approvalAction.actionby === "RejectSubmitBtn") {
      setPopupcontent({
        ...getPopupContent(
          beeImage.RejectedBee,
          "rejectConfirmationBtn",
          approvalAction.rejectOrderconfirmation,
          "Rejected",
          false,
          Popupcontent
        ),
      });
    }
    if (approvalAction.actionby === "ApproveSubmitBtn") {
      setPopupcontent({
        ...getPopupContent(
          beeImage.SuccessBee,
          "approveConfirmationBtn",
          approvalAction.approveOrderconfirmation,
          "Approved",
          true,
          Popupcontent
        ),
      });
    }
    if (approvalAction.actionby === "SubmitOrderBtn") {
      setPopupcontent({
        ...getPopupContent(
          beeImage.SuccessBee,
          "submitConfirmationBtn",
          approvalAction.submitOrderconfirmation,
          "Submitted",
          true,
          Popupcontent
        ),
      });
    }
    setIsOrderApprovalComplete(false);
  }
  if (isApprovalData === false && (approvalAction.actionby === "ApproveSubmitBtn" || approvalAction.actionby === "ReturnSubmitbtn" || approvalAction.actionby === "RejectSubmitBtn" || approvalAction.actionby === "SubmitOrderBtn")) {
    setPopupcontent({
      ...getPopupContent(
        beeImage.RejectedBee,
        "submitConfirmationBtn",
        erroOrderConfirmation,
        "Error..!!",
        false,
        Popupcontent
      ),
    });
  }
}

export const commononUploadClick = (listItem: any, setAttachmentError: any, isUploaded: any, dispatch: any, uploadAttachments: any, id: any, isIdRequired: any) => {
  setAttachmentError("");
  const filteredList = [
    ...listItem.fileList.filter((x: any) => !isUploaded(x.name || (x)?.fileName)),
  ];
  if (filteredList.length > 0 && filteredList.length <= 5) {
    setAttachmentError("");
    let totalSize = 0;
    filteredList.forEach((file: File) => {
      totalSize = totalSize + (file.size || 0);
    });
    if (totalSize <= 5000000) {
      setAttachmentError("");
      const formData = new FormData();
      formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());

      for (let file of filteredList) {
        formData.append("Files", file);
      }
      if (isIdRequired) {
        dispatch(uploadAttachments({ formData, filteredList, list: listItem.uploadedList }, id))
      } else {
        dispatch(uploadAttachments({ formData, filteredList, list: listItem.uploadedList }))
      }
    } else {
      setAttachmentError("Please Upload files without exceeding maximum size of 5MB");
    }
  } else if (listItem.fileList.length > 5) {
    setAttachmentError(
      "Please Upload files without exceeding maximum limit of 5 files"
    );
  } else if (listItem.fileList.length > 0 && !filteredList.length) {
      setAttachmentError("All files are uploaded try to add new files");
  } else {
      setAttachmentError("Choose at least 1 file to upload");
    }
};

export const handleDateFilter = (date: any, search: any, setDate: any) => {
  search(moment(date).format("MM/DD/YYYY"));
  setDate.current = date;
};

export const handleClearDateFilter = (search: any, setDate: any) => {
  search(undefined);
  setDate.current = undefined;
};

export const removeEmptyValues = (filterTable?: any, clearFilterValues?: any) => {
  Object.keys(clearFilterValues)?.map((filterItem?: any) => {
    if (!filterTable[filterItem] && (filterItem != "orderDate" || filterItem != "updatedDate" || filterItem != "dateRange")) {
      filterTable[filterItem] = ""
    } else if (!filterTable[filterItem] && (filterItem == "orderDate" || filterItem == "updatedDate" || filterItem == "dateRange")) {
      filterTable[filterItem] = null
    }

    filterTable['globalSearchField'] = null
    filterTable['orderSearchBoxValue'] = ''
  })
}

//Location tree function for user profile and asset inventory users
export const updateSubCategoryAndCostCenterCount = (treeNode: any) => {
  if (treeNode.children === null) {
    return []
  };

  const subCategories: any = [];
  const costCenter: any = [];

  treeNode?.children?.forEach((acc: any) => {
    if (acc.entityType === 'CostCenter') {
      costCenter.push(acc?.entityId);
    } else {
      subCategories.push(acc);
    }
  });

  treeNode.subcategoryCount = subCategories?.length;
  treeNode.costCenterCount = [...costCenter, ...
    subCategories.reduce((acc: any, subCategory: any) => {
      return [...acc, ...updateSubCategoryAndCostCenterCount(subCategory)];
    }, [])];
  return treeNode.costCenterCount;
};

export const getTooltipText = (id: any, name: any, strcount: any, Item: any, branch?: any) => {
  if (name !== "CostCenter") {
    if (branch?.children?.length) {
      if (name === "Division") {
        return "Click the checkbox to select all locations in the Division or click the plus sign to expand to choose locations"
      }
      const ids = updateSubCategoryAndCostCenterCount(branch);
      let count = 0;
      ids?.forEach((i: any, index: any) => {
        let val = (strcount == 0) ? Number(i) : i + ""

        if (Item.current?.includes(val)) {
          ++count;
        }
      })
      if (count === ids?.length) {
        return "unselect all"
      }
      if (count > 0) {
        return `${count} Cost Center selected`
      }
      if (count === 0) {
        return `select all ${ids?.length} Cost Center`
      }
    }
    return "select all"
  } else {
    let val = (strcount == 0) ? Number(id) : id + ""
    return Item.current?.includes(val) ? "unselect" : "select";
  }
}

export const getEntityLabel = (company: any) => {
  if (company?.entityCode) {
    return `${company?.entityType === 'SuperRegion' ? 'Super Region' : company?.entityType} : ${company?.entityCode} - ${company?.entityName}`
  } else {
    return `${company?.entityType === 'SuperRegion' ? 'Super Region' : company?.entityType} : ${company?.entityName}`
  }
}

export const commonExportExcel = (dataTable: any, columnHeaders: any, name: any, excelName: any) => {
  const ws = XLSX.utils.json_to_sheet(dataTable);
        const wb = XLSX.utils.book_new()
        let wscols = [];
  
        for (let i = 0; i < columnHeaders.length; i++) {
          wscols.push({ wch: columnHeaders[i].length + 5 })
        }
        ws['!cols'] = wscols;
        XLSX.utils.book_append_sheet(wb, ws, name);
        XLSX.writeFile(wb, excelName);
}

export const commonStepperOneOnClick = (setActiveStepper: any, activeStepper: any, StepperRef: any) => {
  setActiveStepper(1);
    if (activeStepper === 2) {
      StepperRef?.current?.children[activeStepper - 2].classList.remove("completed");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
      StepperRef?.current?.children[activeStepper - 1].classList.add("next");
      StepperRef?.current?.children[activeStepper-1].classList.remove("completed");
      StepperRef?.current?.children[activeStepper].classList.remove("next");
    }
    if (activeStepper === 3) {
      StepperRef?.current?.children[activeStepper - 3].classList.remove("completed");
      StepperRef?.current?.children[activeStepper - 2].classList.remove("completed");
      StepperRef?.current?.children[activeStepper - 2].classList.add("next");
      StepperRef?.current?.children[activeStepper].classList.remove("next");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
    }
    if (activeStepper === 4) {
      StepperRef?.current?.children[activeStepper - 4].classList.remove("completed");
      StepperRef?.current?.children[activeStepper - 3].classList.remove("completed");
      StepperRef?.current?.children[activeStepper - 2].classList.remove("completed");
      StepperRef?.current?.children[activeStepper - 3].classList.add("next");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("completed");
    }
}

export const commonStepperTwoOnclick = (setActiveStepper: any, activeStepper: any, StepperRef: any) => {
  setActiveStepper(2);
    if (activeStepper === 1) {
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
      StepperRef?.current?.children[activeStepper].classList.remove("next");
      StepperRef?.current?.children[activeStepper + 1].classList.add("next");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("completed");
    }
    if (activeStepper === 3) {
      StepperRef?.current?.children[activeStepper - 2].classList.remove("completed");
      StepperRef?.current?.children[activeStepper - 1].classList.add("next");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
      StepperRef?.current?.children[activeStepper].classList.remove("next");
    }
    if (activeStepper === 4) {
      StepperRef?.current?.children[activeStepper - 3].classList.remove("completed");
      StepperRef?.current?.children[activeStepper - 2].classList.add("next");
      StepperRef?.current?.children[activeStepper - 2].classList.remove("completed");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("completed");
    }
}

export const commonStepperThreeOnClick = (setActiveStepper: any, activeStepper: any, StepperRef: any) => {
  setActiveStepper(3);
    if (activeStepper === 1) {
      StepperRef?.current?.children[activeStepper + 2].classList.add("next");
      StepperRef?.current?.children[activeStepper].classList.add("completed");
      StepperRef?.current?.children[activeStepper].classList.remove("next");
      StepperRef?.current?.children[activeStepper - 1].classList.add("completed");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
    }
    if (activeStepper === 2) {
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
      StepperRef?.current?.children[activeStepper - 1].classList.add("completed");
      StepperRef?.current?.children[activeStepper].classList.remove("next");
      StepperRef?.current?.children[activeStepper + 1].classList.add("next");
    }
    if (activeStepper === 4) {
      StepperRef?.current?.children[activeStepper - 2].classList.remove("completed");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
      StepperRef?.current?.children[activeStepper - 1].classList.add("next");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("completed");
    }
}

export const commonStepperFourOnClick = (setActiveStepper: any, activeStepper: any, StepperRef: any) => {
  setActiveStepper(4);
    if (activeStepper === 1) {
      StepperRef?.current?.children[activeStepper - 1].classList.add("completed");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
      StepperRef?.current?.children[activeStepper].classList.add("completed");
      StepperRef?.current?.children[activeStepper].classList.remove("next");
      StepperRef?.current?.children[activeStepper + 1].classList.add("completed");
    }
    if (activeStepper === 2) {
      StepperRef?.current?.children[activeStepper - 1].classList.add("completed");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
      StepperRef?.current?.children[activeStepper].classList.add("completed");
      StepperRef?.current?.children[activeStepper].classList.remove("next");
    }
    if (activeStepper === 3) {
      StepperRef?.current?.children[activeStepper - 1].classList.add("completed");
      StepperRef?.current?.children[activeStepper - 1].classList.remove("active");
      StepperRef?.current?.children[activeStepper].classList.remove("next");
    }
}

export const commonDropDownSelectionChange = (item: any, name: string, nextField: number, globalValues: any, setOrderData: any, equipmentRef: any) => {
  let orderDetails = globalValues?.orderDetails;
  let vehicle = globalValues?.vehicle;
  let dispatch = globalValues?.dispatch;
    const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
        if (vehicleRequest?.requestIndex === vehicle?.requestIndex) {
            return {
                ...vehicleRequest,
                searchCriteria: {
                    ...vehicleRequest?.searchCriteria,
                    [name]: item?.value
                }
            }
        }
        return vehicleRequest
    })
    dispatch(setOrderData(tempOrderData))
    equipmentRef.current[nextField]?.focus()
}

export const commonDispValidation = (assetDisposition: any, Validation: any, SubChoiceValidation: any, dispositionTemp: any, isProcessTypeValidationRequired: any) => {
    if (assetDisposition?.assetDispositionChoice?.toLowerCase().includes("write-off with proceeds")) {
        dispositionTemp = { ...Validation.ValidateAssetLocationName(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...Validation.ValidateName(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...Validation.ValidateEmailAddress(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...Validation.ValidatePhone(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...Validation.ValidateAddress1(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...Validation.ValidateCity(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...Validation.ValidateState(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...Validation.ValidateZip(dispositionTemp, { ...dispositionTemp }) };
        dispositionTemp = { ...Validation.ValidateAddress2(dispositionTemp, { ...dispositionTemp }) };
    } else {
        dispositionTemp = {
            ...dispositionTemp,
            assetLocationNameError: "",
            assetLocationAddress1Error: "",
            assetLocationAddress2Error: "",
            assetLocationCityError: "",
            assetLocationStateError: "",
            assetLocationZipError: "",
            assetLocationPhoneError: "",
            assetLotionSalePriceError: "",
            assetLocationContactNameError: "",
            assetLocationContactPhoneError: "",
            assetLocationEmailError: ""
        }
    }

    dispositionTemp = { ...Validation.ValidateDispositionChoice(dispositionTemp, { ...dispositionTemp }) };
    if (isProcessTypeValidationRequired) {
        dispositionTemp = { ...Validation.ValidateProcessType(dispositionTemp, { ...dispositionTemp }) };
    }
    dispositionTemp = { ...SubChoiceValidation.ValidateDispositionSubChoice(dispositionTemp, { ...dispositionTemp }) };
    dispositionTemp = { ...SubChoiceValidation.ValidateName(dispositionTemp, { ...dispositionTemp }) };
    dispositionTemp = { ...SubChoiceValidation.ValidatePhone(dispositionTemp, { ...dispositionTemp }) };
    dispositionTemp = { ...SubChoiceValidation.ValidateAddress1(dispositionTemp, { ...dispositionTemp }) };
    dispositionTemp = { ...SubChoiceValidation.ValidateCity(dispositionTemp, { ...dispositionTemp }) };
    dispositionTemp = { ...SubChoiceValidation.ValidateState(dispositionTemp, { ...dispositionTemp }) };
    dispositionTemp = { ...SubChoiceValidation.ValidateZip(dispositionTemp, { ...dispositionTemp }) };
    dispositionTemp = { ...SubChoiceValidation.ValidateAddress2(dispositionTemp, { ...dispositionTemp }) };
    dispositionTemp = { ...SubChoiceValidation.ValidateSalePrice(dispositionTemp, { ...dispositionTemp }) };
    dispositionTemp = { ...SubChoiceValidation.ValidateTotalPrice(dispositionTemp, { ...dispositionTemp }) };
    return dispositionTemp;
}

export const addFilterGetData = (filterName?: any, dispatch?: any, catalogItemValues?: any, selectedAssetType?: any) => {
    if (filterName == "# of Doors") {
        dispatch(getCatalogUpdateNoOfDoors(catalogItemValues?.vehicleType?.orderRequestSubTypeId, AttributeName.NO_OF_DOORS))
    } else if (filterName == "Year") {
        let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
        dispatch(getCatalogUpdateYear(subTypeId, AttributeName.YEAR))
    } else if (filterName == "Capacity") {
        dispatch(getCatalogUpdateCapacity(catalogItemValues?.vehicleType?.orderRequestSubTypeId, AttributeName.TRUCK_SIZE))
    } else if (filterName == "Upfit") {
        dispatch(getCatalogUpdateUpfit(catalogItemValues?.vehicleType?.orderRequestSubTypeId, AttributeName.UPFIT_OPTION))
    } else if (filterName == "Drive Train") {
        let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
        dispatch(getCatalogUpdateDriveTrain(subTypeId, AttributeName.DRIVE_TRAIN))
    } else if (filterName == "Power Type") {
        let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
        dispatch(getCatalogUpdatePowerType(subTypeId, AttributeName.FUEL_TYPE))
    } else if (filterName == "Vehicle Level") {
        dispatch(getCatalogUpdateVehicleLevel())
    } else if (filterName == "Eq Class Code") {
        let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
        dispatch(getCatalogUpdateEqClassCode(subTypeId))
    } else if (filterName == "Make" || filterName == "Manufacturer") {
        let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
        let isEquipment = selectedAssetType?.assetType?.value !== CONSTANTS.VEHICLE ? AttributeName.MANUFACTURER : AttributeName.MAKE
        dispatch(getCatalogUpdateMake(subTypeId, isEquipment))
    } else if (filterName == "State Availability") {
        let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
        dispatch(getCatalogUpdateStateAvailability(subTypeId, AttributeName.STATE_AVAILABILITY))
    } else if (filterName == "Budgeting Percent") {
        let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
        dispatch(getBudgetingPercentList(subTypeId, AttributeName.BUDGETING_PERCENT))
    } else if (filterName == "Useful Life / Lease Terms") {
        let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
        dispatch(getUsefulLifeList(subTypeId, AttributeName.USEFUL_LIFE_LEASE_TERMS))
    }  else if (filterName == "Tags") {
      let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
      dispatch(getTagsList(subTypeId, AttributeName.USE_TAG))
    } else if (filterName == "Program Status") {
        dispatch(getCatalogUpdateProgramStatus(selectedAssetType?.assetType?.id, AttributeName.PROGRAM_STATUS))
    } else if (filterName == "Annual Hours") {
        dispatch(getCatalogUpdateAnnualHours(selectedAssetType?.assetType?.id, AttributeName.ANNUAL_HOURS))
    } else if (filterName == "Deck Size") {
        dispatch(getCatalogUpdateDeckSize(selectedAssetType?.assetType?.id, AttributeName.DECKSIZE))
    } else if (filterName == "Deck Type") {
        dispatch(getCatalogUpdateDeckType(selectedAssetType?.assetType?.id, AttributeName.DECK_TYPE))
    } else if (filterName == "Size") {
        dispatch(getCatalogUpdateSize(selectedAssetType?.assetType?.id, AttributeName.SIZE))
    } else if (filterName == "Length") {
        dispatch(getCatalogUpdateLength(selectedAssetType?.assetType?.id, AttributeName.LENGTH))
    } else if (filterName == "Autonomous") {
        dispatch(getCatalogUpdateAutonomous(selectedAssetType?.assetType?.id, AttributeName.AUTONOMOUS))
    } else if (filterName == "Category") {
        dispatch(getCatalogUpdateCategory(selectedAssetType?.assetType?.id, AttributeName.CATEGORY))
    } else if (filterName == "Category Type") {
        dispatch(getCatalogUpdateCategoryType(catalogItemValues?.category?.value, AttributeName.CATEGORY_TYPE))
    } else if (filterName == "Category2") {
        dispatch(getCatalogUpdateCategory2(catalogItemValues?.category?.value, AttributeName.CATEGORY2))
    } else if (filterName == "Type") {
        dispatch(getCatalogUpdateType(selectedAssetType?.assetType?.id, AttributeName.TYPE))
    } else if (filterName == "Vehicle Class"){
      let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
      dispatch(getCatalogUpdateVehicleClass(subTypeId, AttributeName.VEHICLE_CLASS))
    } else if (filterName == "Group Type"){
      let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
      dispatch(getCatalogUpdateGroupType(subTypeId, AttributeName.GROUP_TYPE))
    } else if (filterName == "Gross Vehicle Weight Rating"){
      let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
      dispatch(getCatalogUpdateGrossWeight(subTypeId, AttributeName.GROSS_WEIGHT_RATING))
    } else if (filterName == "Class Type"){
      let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
      dispatch(getCatalogUpdateClassType(subTypeId, AttributeName.VEHICLE_TYPE))
    } else if (filterName == "Trim"){
      let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
      dispatch(getCatalogUpdateTrim(subTypeId, AttributeName.TRIM))
    }
}

export const getYearDropdownList = () => {
  let currentMonth = new Date().getMonth() + 1;  // Numeric month (0-based index)
  let currentYear = currentMonth >= 9 ? new Date().getFullYear() + 1 : new Date().getFullYear(); // If current month is greater than or equal to August, increment the year
  let years = [];
  for (let i = 0; i < 15; i++) {
    years.push({ value: currentYear - i, label: currentYear - i })
  }
  return years
}

export const convertToUserTimezone = (utcDate: string): string => {
  const utcDateString = utcDate?.endsWith('Z') ? utcDate : `${utcDate}Z`;
  const date = new Date(utcDateString);
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedDate = new Intl.DateTimeFormat('en-US', {
      timeZone: userTimezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
  }).format(date);
  return formattedDate;
}

export const getBooleanYesNo = (value: any) => {
  if (value === null) {
    return "N/A";
  } else if (value === true) {
    return "Yes";
  } else {
    return "No";
  }
};

export const CONSTRUCTION_EQUIPMENT_CATEGORY_WITH_CATEGORY_2 = [CONSTANTS.CONSTRUCTION_EQUIPMENT_CATEGORY.EXCAVATOR, CONSTANTS.CONSTRUCTION_EQUIPMENT_CATEGORY.LOADER, CONSTANTS.CONSTRUCTION_EQUIPMENT_CATEGORY.SKID_STEER]
export const STANDARDIZED_EQUIPMENT_CATEGORY_WITH_CATEGORY_2 = [
  CONSTANTS.STANDARDIZED_EQUIPMENT_CATEGORY.SKID_SPRAY_UNIT,
  CONSTANTS.STANDARDIZED_EQUIPMENT_CATEGORY.EDGERS,
  CONSTANTS.STANDARDIZED_EQUIPMENT_CATEGORY.BLOWERS,
  CONSTANTS.STANDARDIZED_EQUIPMENT_CATEGORY.AERATOR,
  CONSTANTS.STANDARDIZED_EQUIPMENT_CATEGORY.OVERSEEDER,
  CONSTANTS.STANDARDIZED_EQUIPMENT_CATEGORY.LEAF_VAC
]
export const SNOW_CATEGORY_WITH_CATGORY_TYPE = [CONSTANTS.SNOW_CATEGORY.PLOW]

export const formatVinSerial = (value: string): string => {
  if (!value) return '';
  
  // Remove all non-alphanumeric characters (including spaces and special characters)
  const alphanumericOnly = value.replace(/[^a-zA-Z0-9]/g, '');
  
  // Convert to uppercase
  return alphanumericOnly.toUpperCase();
};

